import React from 'react'
import PropTypes from 'prop-types'
import { Controller } from 'react-hook-form'
import { FormControl, TextField } from '@mui/material'
import MuiDatePicker from '@mui/lab/DatePicker'
import AdapterDateFns from '@mui/lab/AdapterDateFns'
import LocalizationProvider from '@mui/lab/LocalizationProvider'
import { dateFormatter } from 'utils/data-manipulation/valueFormatter'
import { useSelector } from 'react-redux'
import { getDateFormatPatternFromLocale } from 'utils/helpers'
import dayjs from 'dayjs'

const DatePicker = ({ name, label, control, variant, defaultDate, datePickerProps, ...restProps }) => {
  const labelId = `${name}-label`
  const { locale } = useSelector(state => state.auth)
  const { dateFormat, muiDateFormat } = getDateFormatPatternFromLocale(locale)

  return (
    <FormControl sx={{ width: '100%' }}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Controller
          render={({ field: { onChange, value } }) => (
            <MuiDatePicker
              labelId={labelId}
              label={label}
              value={value}
              onChange={onChange}
              inputFormat={muiDateFormat}
              {...datePickerProps}
              renderInput={params => {
                const dateValue = dayjs(params.inputProps.value, dateFormat).valueOf()
                const inputValue =
                  !isNaN(dateValue) && dayjs(dateValue).isValid() ? dateFormatter(dateValue) : params.inputProps.value
                return (
                  <TextField
                    variant={variant}
                    {...params}
                    {...restProps}
                    InputProps={{
                      ...(params.InputProps || {}),
                      ...(restProps.InputProps || {}),
                    }}
                    inputProps={{
                      ...(params.inputProps || {}),
                      ...(restProps.inputProps || {}),
                      value: inputValue,
                      placeholder: dateFormat,
                    }}
                  />
                )
              }}
            />
          )}
          name={name}
          control={control}
          defaultValue={defaultDate}
        />
      </LocalizationProvider>
    </FormControl>
  )
}

DatePicker.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  variant: PropTypes.string,
  defaultDate: PropTypes.instanceOf(Date),
  control: PropTypes.instanceOf(Object).isRequired,
  datePickerProps: PropTypes.object,
}

DatePicker.defaultProps = {
  variant: 'standard',
  defaultDate: null,
  datePickerProps: {},
}

export default DatePicker
